<script setup lang="ts">
import { onUnmounted, ref } from "vue";
import { mouseEnter$, mouseLeave$ } from "@zyzgroup/core-web";
import Box from "./Box.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(defineProps<{}>(), {});

const emits = defineEmits<{
  (event: "enter", e: MouseEvent): void;
  (event: "leave", e: MouseEvent): void;
}>();

const isEnter = ref(false);

let s1;
let s2;

const mount = (box) => {
  if (!s1) {
    s1 = mouseEnter$(box.el).subscribe((e) => {
      isEnter.value = true;
      emits("enter", e);
    });
  }
  if (!s2) {
    s2 = mouseLeave$(box.el).subscribe((e) => {
      isEnter.value = false;
      emits("leave", e);
    });
  }
};

onUnmounted(() => {
  s1?.unsubscribe();
  s2?.unsubscribe();
});

defineExpose({});
</script>

<template>
  <Box
    class="mouse"
    display-type="shrink"
    :style="{ cursor: isEnter ? 'pointer' : 'auto' }"
    @mount="mount"
  >
    <slot></slot>
  </Box>
</template>

<style></style>
